import { useNavigate, useLocation } from "react-router-dom";
import { Home, LayoutGrid, PawPrint, User, ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export const BottomTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cartCount } = useCart();
  const { user } = useAuth();

  const mePath = !user ? "/login" : user.role === "admin" ? "/admin" : user.role === "seller" ? "/seller" : user.role === "delivery" ? "/delivery" : "/account";

  const tabs = [
    { key: "home", label: "Home", icon: Home, to: "/", match: (p) => p === "/" },
    { key: "category", label: "Category", icon: LayoutGrid, to: "/category", match: (p) => p.startsWith("/category") },
    { key: "zoomies", label: "Zoomies", icon: PawPrint, to: "/zoomies", match: (p) => p.startsWith("/zoomies") },
    { key: "me", label: "Me", icon: User, to: mePath, match: (p) => ["/account", "/seller", "/admin", "/delivery"].some((x) => p.startsWith(x)) },
    { key: "cart", label: "Cart", icon: ShoppingCart, to: "/cart", match: (p) => p.startsWith("/cart"), badge: cartCount },
  ];

  return (
    <nav data-testid="bottom-tab-bar" className="fixed bottom-0 inset-x-0 z-40 bg-background/95 backdrop-blur-xl border-t border-border/60 pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-2xl mx-auto grid grid-cols-5">
        {tabs.map((tab) => {
          const active = tab.match(location.pathname);
          const Icon = tab.icon;
          return (
            <button
              key={tab.key}
              data-testid={`tab-${tab.key}`}
              onClick={() => navigate(tab.to)}
              className="relative flex flex-col items-center gap-0.5 py-2 transition-colors"
            >
              <span className={`relative flex items-center justify-center w-9 h-9 rounded-full transition-all ${active ? "bg-primary text-white" : "text-muted-foreground"}`}>
                <Icon className="w-5 h-5" />
                {tab.badge > 0 && (
                  <span data-testid={`tab-${tab.key}-badge`} className="absolute -top-1 -right-1 min-w-4 h-4 px-1 rounded-full bg-destructive text-white text-[10px] font-bold flex items-center justify-center">{tab.badge}</span>
                )}
              </span>
              <span className={`text-[11px] font-medium ${active ? "text-primary" : "text-muted-foreground"}`}>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
